<template>
    <div class="min_box">
        <div class="flex" >
            <div><a-button class="top_btn" type="primary"   @click="exportList()"  >
                批量导出
            </a-button>
                <span style="margin-left: 8px">
        <template v-if="hasSelected">
          {{ `选中 ${selectedRowKeys.length} 项` }}
        </template></span></div>
           
        </div>
        <a-table :columns="columns" :data-source="data" :loading="loading" :pagination="false" rowKey="id" @change="handleChange" :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }" >
            <span slot="action" slot-scope="text, record">
                <a @click="gotoStatistics(record)">{{text.customer_count}}</a>
            </span>
        </a-table>
    </div>

</template>

<script>
    import API from "./api";
    import {changStatus, removeById,orderList} from "../../../utils/utils"
    const columns = [

        {
            title: "网站类型名称",
            key: "name",
            width:"50%",
            ellipsis: true,
            dataIndex: "name",
        },
        {
            title: "客户数",
            key: "action",
            scopedSlots: {customRender: "action"}
            /* key: "customer_count",
            dataIndex: "customer_count", */
        }
    ];
    export default {
        name: 'index',
        data() {
            return {
                loading: true,
                data: [],
                selectedRowKeys: [], // Check here to configure the default column
                columns,
            }
        },
        created() {
            this.$store.state.adminleftnavnum = "/DataStatistics/RankType"; //设置左侧导航2-2 active
        },
        computed: {
            hasSelected() {
                return this.selectedRowKeys.length > 0;
            },
        },
        methods: {
            empty(){
                this.search.name=""
                this.getList()
            },
            handleChange(pagination, filters, sorter) {
            },
            exportList(){
                API.service.EXPORT({ids:this.selectedRowKeys }).then(res => {
                    window.open( `${this.$store.state.urlExper}${res.data.data.path.substr(1)}`  )
                })
            },
            getList(page) {
                API.service.GET_LIST({page: page || 1}).then(res => {
                    this.data = res.data.data
                    this.selectedRowKeys=[]
                    this.loading = false
                })
            },

            onSelectChange(selectedRowKeys) {
                this.selectedRowKeys = selectedRowKeys;
            },
            gotoStatistics(row){
                this.$router.push(`/DataStatistics/WebStatistics?id=${row.id}&name=${row.name}&type=siteType`)
            }
        },
        mounted() {
            this.getList()
        }

    }
</script>
<style scoped>
    .inputs {
        display: inline-block;
        width: 70px
    }
    .search-group {
        float: right;
    }
    .search-group .seachs {
        width: 200px;
        margin: 0 8px 0 10px ;
    }
    .button-group {
        float: left;
    }
    #list_order {
        width: 50px;
    }
    .top .flex{ box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);padding:10px 16px;box-sizing: border-box;width: 60%;margin-bottom: 20px}
    .min_box{width: 60%}
</style>
